import React from 'react';
import _ from 'lodash';
import cx from 'classnames';

// material-ui imports
import { Theme } from '@material-ui/core/styles/createMuiTheme';
import { withStyles } from '@material-ui/core/styles';
import {
  WithStyles,
  createStyles,
  InputLabel,
  InputBase,
  FormHelperText,
  Typography
} from '@material-ui/core';
import { fade } from '@material-ui/core/styles/colorManipulator';
import { Error } from '@material-ui/icons';
import { SectionFocusedContext, SectionFocusedContextValue } from './MyPATBaseSection';

// styles
const styles = (theme: Theme) => createStyles({
  textAreaControl: {
    margin: 0,
    border: 0,
    display: 'flex',
    padding: 0,
    position: 'relative',
    minWidth: 0,
    flexDirection: 'column',
    verticalAlign: 'top',
  },
  inputDiv: {
    border: '1px solid #dfdfdf',
    marginTop: '2%',
    borderRadius: '4px',

  },
  inputRoot: {
    'label + &': {
      marginTop: theme.spacing.unit * 3,
      padding: 0,
    },
    display: 'flex'
    
  },
  input: {
    borderRadius: theme.shape.borderRadius,
    position: 'relative',
    backgroundColor: 'white',
    fontSize: 16,
    padding: '12px',
    transition: theme.transitions.create(['border-color', 'box-shadow']),
    boxSizing: 'border-box',
    '&:focus': {
      borderColor: '#a1a1a1',
    },
  },
  inputFormLabel: {
    fontSize: 18,
    top: 0,
    left: 0,
    position: 'absolute',
    color: theme.palette.text.primary,
    "& > span": {
      color: theme.palette.error.light,
    }
  },
  formControlError: {
    '& > div textarea': {
      background: fade(theme.palette.error.light, 0.1),
    },
    '& > label': {
      color: theme.palette.error.light,
    },
    '& >  p': {
      color: theme.palette.error.light,
    },
  },
  formControl: {
    marginBottom: theme.spacing.unit,
  },
  helperText:{
    display: 'flex',
    flexDirection: 'row-reverse'
  },
  errorText: {
    color: theme.palette.error.light,
    verticalAlign: 'middle',
    marginTop: '3px',
    '& svg': {
      verticalAlign: 'bottom',
      marginRight: '5px',
    }
  },
});

interface MyPATTextAreaProps extends WithStyles<typeof styles> {
  fullWidthControl: boolean,
  fullWidthInput: boolean,
  required: boolean,
  label: string,
  inputId: any,
  helperText: string,
  error: boolean,
  errorText: string,
  inputProps: object,
  multiline: boolean;
  onFocus?: (event: any) => void;
  onBlur?: (event: any) => void;
}

const MyPATTextArea = (props: MyPATTextAreaProps) => {
  const handleFocusAndBlur = (
    e: any,
    setSectionFocus: SectionFocusedContextValue["setSectionFocus"],
    isFocused: boolean
  ) => {
    const { onFocus, onBlur } = props;
    setSectionFocus(isFocused);
    if (isFocused) {
      onFocus && onFocus(e);
    } else {
      onBlur && onBlur(e);
    }
  };
  const {
    classes,
    fullWidthControl = false,
    fullWidthInput = false,
    required = false,
    label,
    inputId,
    helperText,
    error = false,
    errorText,
    onFocus,
    onBlur,
    ...inputProps
  } = props;

  return (
    <SectionFocusedContext.Consumer>
      {({ setSectionFocus, focusedBorder }: SectionFocusedContextValue) => (
      <div className={cx(classes.textAreaControl, classes.formControl, (error ? classes.formControlError : ""))} style={{ width: fullWidthControl && '100%' }}>
        {_.isEmpty(label) || (
          <InputLabel shrink htmlFor={inputId} className={classes.inputFormLabel} required={required}>
            {label}
          </InputLabel>
        )}
        <div className={classes.inputDiv}>
        <InputBase
          id={inputId}
          classes={{
            root: classes.inputRoot,
            input: classes.input,
            focused: focusedBorder
          }}
          fullWidth={fullWidthInput}
          required={required}
          {...inputProps}
          onFocus={(e) =>
            handleFocusAndBlur(e, setSectionFocus, true)
          }
          onBlur={(e) =>
            handleFocusAndBlur(e, setSectionFocus, false)
          }
        />
        {
          _.isEmpty(helperText) || (
            <FormHelperText className={classes.helperText}>
              {helperText}
            </FormHelperText>
          )
        }
        </div>
        {
          error && (
            <Typography className={classes.errorText} variant="caption" color="error"><Error />{errorText}</Typography>
          )
        }
      </div>
      )}
    </SectionFocusedContext.Consumer>
        
  );
};

export default withStyles(styles)(MyPATTextArea);